import { Compass, ScrollText } from 'lucide-react'
import {
  Badge,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  isActive: (path: string) => boolean
  onNavigate: (path: string) => void
}

export const ResourcesGroup = ({ isActive, onNavigate }: Props) => {
  const m = useMessages(messages)
  return (
    <SidebarGroup>
      <SidebarGroupLabel>{m.resources}</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {/* Explore — курсы сообщества: всё из каталога и курсы по ссылке с галочкой
              «Показывать в Explore». */}
          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isActive('/explore')}
              onClick={() => onNavigate('/explore')}
            >
              <Compass className="size-[17px]" />
              <span>{m.explore}</span>
            </SidebarMenuButton>
          </SidebarMenuItem>

          {/* «Академии» скрыты по решению заказчика. */}
          <SidebarMenuItem>
            <SidebarMenuButton disabled className="opacity-50 cursor-not-allowed">
              <ScrollText className="size-[17px]" />
              <span>{m.skills}</span>
              <Badge variant="neutral" className="ml-auto">
                {m.soon}
              </Badge>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
